import { render, staticRenderFns } from "./nosotros.vue?vue&type=template&id=f8006c20&scoped=true"
import script from "./nosotros.vue?vue&type=script&lang=js"
export * from "./nosotros.vue?vue&type=script&lang=js"
import style0 from "./nosotros.vue?vue&type=style&index=0&id=f8006c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8006c20",
  null
  
)

export default component.exports